import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, SerializationContext, DataModelBuilder, SerializedData } from '../dto/dto.js';

export class CompactAppointmentSettings extends DataModel {
  static readonly TYPE_ID: string = '4ace5e717e004fa4bb2e8ebd27a16653a';

  constructor(
        public readonly enabled: boolean,
        public readonly shrinkAmount: number,
  ) {
    super();
  }

  get $typeId(): string {
    return CompactAppointmentSettings.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): CompactAppointmentSettings {
    return new CompactAppointmentSettings(
        MapUtils.get<boolean>(map, 'enabled'),
        MapUtils.get<number>(map, 'shrinkAmount'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'enabled': this.enabled,
      'shrinkAmount': this.shrinkAmount,
    };
  }

  clone(): this {
    return new CompactAppointmentSettings(
        this.enabled,
        this.shrinkAmount,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.enabled === this.enabled &&
        other.shrinkAmount === this.shrinkAmount;
  }
}

export class CompactAppointmentSettingsBuilder extends DataModelBuilder<CompactAppointmentSettings> {
  build(context: SerializationContext, map: SerializedData): CompactAppointmentSettings {
    return CompactAppointmentSettings.fromMap(context, map);
  }
}
